/**
 * 
 */
(function() {
	angular.module("cbl.insuranceloanpmi.mf").service("MappingSrvc", [ function() {
		this.values = [];
		var self = this;

		this.getValue = function(key) {
			var res = self.values[key];
			if (res === undefined || res === "") {
				res = "UNDEFINED VALUE";
			}
			return res;
		};
		
	} ]);
}());



//////////////////
// WEBPACK FOOTER
// ./app/components/servicesUtilities/mappingSrvc.js
// module id = 32
// module chunks = 0 1